import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import CashregistersList from './CashregistersList/CashregistersList';
import CashregisterShow from './CashregisterShow/CashregisterShow';
import CashregisterEdit from './CashregisterEdit/CashregisterEdit';
import CashregisterCreate from './CashregisterCreate/CashregisterCreate';
import CashregisterDelete from './CashregisterDelete/CashregisterDelete';

const Cashregisters = ({ match }) => {
    return (
        <div className="Cashregisters">
            <ContainerWrapper container="cashregisters">
                <Route exact path={ match.path } component={CashregistersList} />
                <Route exact path={ `${ match.url }/new` } component={CashregisterCreate} />
                <Route exact path={ `${ match.url }/show/:cashregisterId` } component={CashregisterShow} />
                <Route exact path={ `${ match.url }/edit/:cashregisterId` } component={CashregisterEdit} />
                <Route exact path={ `${ match.url }/delete/:cashregisterId` } component={CashregisterDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Cashregisters;
